/**
 * Today's calendar date in America/Chicago as "YYYY-MM-DD" — QA-17. The
 * firm works in Central time; `new Date().toISOString()` is UTC and flips to
 * tomorrow at 7 pm CDT. The `en-CA` locale formats as year-month-day.
 */
export function todayCentral(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Chicago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}
